import React from 'react'

export const ShieldWarning = props => (
  <svg
    width={48}
    height={48}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        fill-rule="evenodd" 
        clip-rule="evenodd"
        d="M25.4044 4.39043L39.4044 9.64043C40.9658 10.2259 42 11.7184 42 13.3857V24.1112C42 30.929 38.148 37.1618 32.0498 40.2108L25.3416 43.565C24.497 43.9872 23.503 43.9872 22.6584 43.565L15.9502 40.2108C9.85204 37.1618 6 30.929 6 24.1112V13.3857C6 11.7184 7.0343 10.2259 8.5955 9.64043L22.5956 4.39043C23.501 4.05085 24.499 4.05085 25.4044 4.39043ZM24 28C22.8954 28 22 28.8954 22 30C22 31.1046 22.8954 32 24 32C25.1046 32 26 31.1046 26 30C26 28.8954 25.1046 28 24 28ZM24 14C22.9743 14 22.129 14.7721 22.0135 15.7668L22 16V24C22 25.1046 22.8954 26 24 26C25.0257 26 25.871 25.228 25.9865 24.2333L26 24V16C26 14.8954 25.1046 14 24 14Z"
    />
  </svg>
)
